import Input from '@vromo/ui/components/Input';
import { action } from 'mobx';
import { observer } from 'mobx-react-lite';
import { Campaign } from 'models';
import React, { ChangeEvent } from 'react';
import { qaLabelCampaigns } from './../../../../../../common-qa-labels/campaigns';
import { useTranslation } from 'react-i18next';

interface Props {
    campaign: Campaign;
}

const General = observer(({ campaign }: Props) => {
    const { t } = useTranslation();

    return (
        <div>
            {campaign.id && (
                <>
                    <label>{t('campaign.id')}</label>
                    <div style={{ marginBottom: 20 }}>{campaign.id}</div>
                </>
            )}
            <label>{t('campaign.name')}</label>
            <Input
                data-testid={qaLabelCampaigns.editModal.nameInput}
                value={campaign.name}
                onChange={action(
                    (e: ChangeEvent<HTMLInputElement>) => (campaign.name = e.target.value)
                )}
            />
            <hr />
            <label>{t('campaign.googleAnalytics')}</label>
            <Input
                placeholder="G-XXXXXXXXX1"
                value={campaign?.analytics?.google || ''}
                onChange={action((e: ChangeEvent<HTMLInputElement>) => {
                    if (!campaign?.analytics) {
                        campaign.analytics = { google: '' };
                    } else if (e.target.value === '') {
                        campaign.analytics = {};
                        return;
                    }
                    campaign.analytics.google = e.target.value;
                })}
            />
        </div>
    );
});

export default General;
